import { Icon, IconName } from "@design-system/Icon";
import { Box } from "@design-system/Layout/Box";
import { cn } from "@design-system/Utilities";
import { type ClassValue } from "class-variance-authority/types";
import { type FC } from "react";

export const tagStatus = {
    todo: "todo",
    inProgress: "inProgress",
    validated: "validated",
    notMaterial: "notMaterial",
    checked: "checked",
    loading: "loading",
    missed: "missed",
    defined: "defined",
} as const;

export type TagStatus = keyof typeof tagStatus;

export const StatusTagCircular: FC<{
    status: TagStatus;
    className?: ClassValue;
    size?: "xs" | "sm" | "md" | "lg";
}> = ({ status, className, size }) => {
    const getStatusTagCircularIcon = (status: TagStatus): IconName => {
        switch (status) {
            case tagStatus.todo:
                return "circleTodo";
            case tagStatus.inProgress:
                return "circleInProgress";
            case tagStatus.validated:
                return "circleValidated";
            case tagStatus.notMaterial:
                return "eyeOff";
            case tagStatus.checked:
                return "check";
            case tagStatus.loading:
                return "circleLoading";
            case tagStatus.missed:
                return "circleCross";
            case tagStatus.defined:
                return "target";
        }
    };
    const iconName = getStatusTagCircularIcon(status);

    return (
        <Box
            alignItems="center"
            className={cn(
                className,

                status === tagStatus.notMaterial &&
                    "rounded-[720px] bg-neutral-150",
                status === tagStatus.defined && "text-accent-700",
            )}
            justifyContent="center"
        >
            <Icon name={iconName} size={size || "sm"} />
        </Box>
    );
};
